export const sortAccordingTo = <R = any, D = any>(
  reference: R[],
  data: D[],
  referenceKeySelector: (r: R) => string,
  dataKeySelector: (d: D) => string,
) => {
  if (reference.length === 0) return data;
  const referenceKeys = reference.map(r => referenceKeySelector(r));
  const dataKeys = data.map(d => dataKeySelector(d));
  return referenceKeys.map(key => {
    const dataIndex = dataKeys.indexOf(key);
    return data[dataIndex]
  }).filter(Boolean);
}